<template>
  <div v-if="isValid">
    <v-main>
      <v-container>
        <v-form ref="form" lazy-validation>
          <v-flex xs12 text-xs-center>
            <v-img
              :src="require('../assets/hp-logo.gif')"
              class="my-3"
              contain
              height="200"
            ></v-img>
          </v-flex>

          <v-flex xs12 text-xs-center>
            <h1 class="display-2 font-weight-bold mb-3" align="center">
              {{ companyName }} {{ year }}
            </h1>
          </v-flex>
          <br />

          <v-flex mb-5 xs12>
            <h2 class="headline font-weight-bold mb-3">
              1. How easy was it to get your voucher from Healthy Performance?
            </h2>

            <v-radio-group
              v-model="answers.experience"
              :rules="[rules.required]"
              row
            >
              <v-radio label="Very easy" value="veryeasy"></v-radio>
              <v-radio label="Easy" value="easy"></v-radio>
              <v-radio label="It was ok" value="ok"></v-radio>
              <v-radio label="Quite difficult" value="quitedifficult"></v-radio>
              <v-radio label="Very difficult" value="verydifficult"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2 class="headline font-weight-bold mb-3">
              2.How easy was it to organise your vaccine with your chosen
              pharmacy?
            </h2>

            <v-radio-group
              v-model="answers.findpharmacy"
              :rules="[rules.required]"
              row
            >
              <v-radio label="Very easy" value="veryeasy"></v-radio>
              <v-radio label="Easy" value="easy"></v-radio>
              <v-radio label="It was ok" value="ok"></v-radio>
              <v-radio label="Quite difficult" value="quitedifficult"></v-radio>
              <v-radio label="Very difficult" value="verydifficult"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2 class="headline font-weight-bold mb-3">
              3. How would you rate your experience in the pharmacy?
            </h2>

            <v-radio-group
              v-model="answers.pharmacyExperience"
              :rules="[rules.required]"
              row
            >
              <v-radio label="Excellent" value="excellent"></v-radio>
              <v-radio label="Very Good" value="verygood"></v-radio>
              <v-radio label="Good" value="good"></v-radio>
              <v-radio label="Average" value="average"></v-radio>
              <v-radio label="Poor" value="poor"></v-radio>
            </v-radio-group>
          </v-flex>

          <!-- <v-flex mb-5 xs12>
            <h2 class="headline font-weight-bold mb-3">
              4. Which pharmacy did you use for your vaccination?
            </h2>

            <v-radio-group
              v-model="answers.pharmacy"
              :rules="[rules.required]"
              column
            >
              <v-radio label="Lloyds Pharmacy" value="lloyds"></v-radio>
              <v-radio
                label="Sainsbury’s Pharmacy"
                value="sainsburys"
              ></v-radio>
              <v-radio label="Asda Pharmacy" value="asda"></v-radio>
              <v-radio label="Deers Pharmacy" value="deers"></v-radio>
              <v-radio label="Kamsons Pharmacy" value="kamsons"></v-radio>
              <v-radio label="Don't Know" value="dontknow"></v-radio>
            </v-radio-group>
          </v-flex> -->

          <!-- <v-flex mb-5 xs12>
            <h2 class="headline font-weight-bold mb-3">
              5. How would you rate our post vaccine communication?
            </h2>

            <v-radio-group
              v-model="answers.communication"
              :rules="[rules.required]"
              row
            >
              <v-radio label="Excellent" value="excellent"></v-radio>
              <v-radio label="Very Good" value="verygood"></v-radio>
              <v-radio label="Good" value="good"></v-radio>
              <v-radio label="Average" value="average"></v-radio>
              <v-radio label="Poor" value="poor"></v-radio>
            </v-radio-group>
          </v-flex> -->

          <v-flex mb-5 xs12>
            <h2 class="headline font-weight-bold mb-3">
              4. Overall, would you recommend Healthy Performance flu vouchers?
            </h2>

            <v-radio-group
              v-model="answers.recommend"
              :rules="[rules.required]"
              row
            >
              <v-radio label="No" value="no"></v-radio>
              <v-radio label="Yes" value="yes"></v-radio>
            </v-radio-group>
          </v-flex>

          <!-- <v-flex mb-5 xs12 v-if="answers.previousVoucher === 'yes'">
            <h2 class="headline font-weight-bold mb-3">
              Did you find our flu voucher easier to use than on previous
              occasions?
            </h2>

            <v-radio-group
              v-model="answers.easierToUse"
              :rules="[rules.required]"
              column
            >
              <v-radio label="Yes" value="yes"></v-radio>
              <v-radio label="Similar" value="similar"></v-radio>
              <v-radio label="No" value="no"></v-radio>
            </v-radio-group>
          </v-flex> -->

          <v-flex mb-5 xs12>
            <h2 class="headline font-weight-bold mb-3">
              5. Would you like to make any further comments about your flu
              voucher experience with Healthy Performance?
            </h2>

            <v-textarea
              v-model="answers.comment"
              name="input-7-1"
              filled
              label="Please type here..."
            ></v-textarea>
          </v-flex>

          <v-btn block color="#b0cf3d" class="float-right mb-10" @click="save"
            >Submit</v-btn
          >
        </v-form>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import { API, graphqlOperation } from "aws-amplify";
import * as queries from "./../graphql/queries";
import * as mutations from "./../graphql/mutations";
export default {
  async created() {
    var that = this;
    API.graphql(
      graphqlOperation(queries.getSurveyDigitalVoucher, {
        id: this.$route.params.id
      })
    )
      .then(result => {
        this.isValid = true;
        let answer = result.data.getSurveyDigitalVoucher;
        this.companyName = answer.company;
        this.answers = {};

        for (var property in answer) {
          if (answer.hasOwnProperty(property)) {
            if (answer[property]) {
              this.answers[property] = answer[property];
            }
          }
        }
      })
      .catch(() => {
        that.isValid = false;
      });
  },
  data: () => ({
    answers: [],
    isValid: true,
    companyName: "",
    year: new Date().getFullYear(),
    rules: {
      required: v => !!v || "This field is required."
    }
  }),
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        const answers = {
          id: this.answers.id,
          experience: this.answers.experience,
          findpharmacy: this.answers.findpharmacy,
          pharmacyExperience: this.answers.pharmacyExperience,
          recommend: this.answers.recommend,
          comment: this.answers.comment
        };

        API.graphql(
          graphqlOperation(mutations.updateSurveyDigitalVoucher, {
            input: answers,
          })
        )
          .then(() => {
            this.$router.push({ path: "/thankyou" });
          })
          .catch(err => (this.error = err.message));
      }
    }
  }
};
</script>

<style>
.v-radio {
  margin-right: 50px;
}
</style>